import React, { useCallback, useEffect, useRef, useState } from "react";

import { Form } from "@unform/web";
import { Modal } from "@material-ui/core";
import { cloneDeep } from "lodash";
import { useParams } from "react-router-dom";
import { PagesProps } from "../../../../dtos/PagesProps";
import { FormHandles } from "@unform/core";
import { useMainHook } from "../../../../hooks/main";
import { useSelection } from "../../hooks/selection";

import {
  ContainerButtonsYesNo,
  ContainerLoading,
  ContainerModalDocumentName,
  ContainerSidebarNav,
  ContainerVariables,
  LabelDocumentName,
  ListDocumentsContainer,
  ModalContainer,
  NoVariables,
  NoVariablesLabel,
  SubContainerSideBarNav
} from "./styles";

import * as Yup from "yup";
import ReactQuill from "react-quill";
import html2canvas from "html2canvas";
import Input from "./components/Input";
import api from "../../../../services/api";
import ButtonPrimary from "../ButtonPrimary";
import LoadingEditor from "../LoadingEditor";
import Variables from "./components/Variables";
import AutomatizedItem from "./components/AutomatizedItem";
import getVariablesFromText from "../../utils/getVariablesFromText";
import PreviewDocument from "../../../../shared/components/PreviewDocument";
import DownloadDocument from "../../../../shared/components/DownloadDocument";
import getValidationErrors from "../../../../utils/getValidationsErrors";
import { toast } from "react-toastify";
import { ContractAnimation } from "../../../../shared/components/ContractAnimation";
import { useToolbarEditor } from "../../hooks/toolbarEditor";

interface IAutomatizationAPI {
  automation_user_template_id: string;
  created_at: string;
  description: null | string;
  id: string;
  is_automation: true;
  thumbnail: string;
  thumbnail_url: string;
  title: string;
  updated_at: string;
  user_id: string;
}

interface IShowAutomatizedDocumentAPI {
  automation_user_template_id: string;
  created_at: string;
  description: null | string;
  download_counter: number;
  id: string;
  is_automation: boolean;
  save_counter: number;
  template: { arrayOfPages: PagesProps[] };
  thumbnail: string;
  thumbnail_url: string;
  title: string;
  updated_at: string;
  user_id: string;
}

const AutomatizingTab: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const {
    setSelectedObject,
    selectedObject,
    IsModalVisible,
    setIsModalVisible
  } = useSelection();

  const [isModalNameDocumentVisible, setIsModalNameDocumentVisible] =
    useState(false);
  const [isModalDeleteDocumentVisible, setIsModalDeleteDocumentVisible] =
    useState(false);
  const [documentVariables, setDocumentVariables] = useState<string[]>([]);
  const [listDocumentsAutomatized, setListDocumentsAutomatized] = useState<
    IAutomatizationAPI[]
  >([]);
  const [loading, setLoading] = useState<
    | "download"
    | "variables"
    | "automatize"
    | "automatizing"
    | "saving"
    | "deleting"
    | "preview"
    | "pages"
    | false
  >(false);
  const [modalPreviewDocumentVisiblle, setModalPreviewDocumentVisible] =
    useState(false);

  const idCurrentAutomatizedDocument = useRef<string | null>(null);
  const documentAutomatized = useRef(null);
  const quillRefComponent = useRef<ReactQuill>(null);
  const documentPreviewData = useRef<PagesProps[] | null>(null);
  const [downloading, setDownloading] = useState(false);
  const automatizedTabRef = useRef<HTMLDivElement>(null);
  const automatizedDocumentsPageNumber = useRef<number | "FINAL">(0);

  const { blockCommandKeyboard, forceBlockKey, setForceBlockKey } =
    useToolbarEditor();

  const documentName = useRef("");

  const { objectScreen, setObjectScreen, documentID } = useMainHook();
  const { templateid } = useParams();

  const modules = React.useMemo(
    () => ({
      toolbar: false
    }),
    []
  );

  //fixing issue of copy and paste into canvas instead
  // of inputs native copy and paste
  useEffect(() => {
    setForceBlockKey(IsModalVisible);
  }, [IsModalVisible]);

  // this useEffect brings all the page automatizations
  useEffect(() => {
    (async () => {
      try {
        const fetchAutomatizedDocuments = await api.get(
          `user-templates/list-automation-user-template/${templateid}`
        );

        setListDocumentsAutomatized(fetchAutomatizedDocuments.data.dataArray);
      } catch (error) {
        console.log("error getting lists of documents automatized");
        console.log(error?.response?.data);
      }
    })();
  }, []);

  const getVariablesFromProject = useCallback(() => {
    setDocumentVariables([]);
    let variables: string[] = [];

    objectScreen.forEach((page, index) => {
      page.renderObjects.forEach(renderedObject => {
        if (renderedObject.text) {
          variables.push(...getVariablesFromText(renderedObject.text));
        }
      });
    });

    // removing repeated variables
    let filteredVariables = variables.filter(function (el, i) {
      return variables.indexOf(el) === i;
    });

    setDocumentVariables(filteredVariables);
  }, [objectScreen]);

  const handleOpenModal = useCallback(() => {
    setIsModalVisible(true);

    getVariablesFromProject();
  }, [selectedObject, objectScreen]);

  const handleCloseModal = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) {
        setIsModalVisible(false);
        setIsModalNameDocumentVisible(false);
        setIsModalDeleteDocumentVisible(false);
        setModalPreviewDocumentVisible(false);
      }
    },
    []
  );

  const handleAutomatizeDocument = useCallback(
    async data => {
      try {
        let yupShape = {};

        Object.keys(data).forEach((key, index) => {
          yupShape[key] = Yup.string();
        });

        const schema = Yup.object().shape({ ...yupShape });

        await schema.validate(data, {
          abortEarly: false
        });

        setLoading("automatizing");
        let cloneObjectScreen = cloneDeep(objectScreen);

        // Replacing all my variables for values in inputs
        Object.keys(data).forEach((variable, index) => {
          cloneObjectScreen.forEach((page, index) => {
            page.renderObjects.forEach((renderedObject, index) => {
              //replacing text of object
              if (renderedObject?.text) {
                renderedObject.text = renderedObject.text.replace(
                  variable,
                  data[variable]
                );
              }

              // replacing variable inside of format
              if (renderedObject?.format?.ops) {
                renderedObject.format.ops.forEach((formatObj, index) => {
                  formatObj.insert = formatObj.insert.replace(
                    variable,
                    data[variable]
                  );
                });
              }
            });
          });
        });

        // Rendering images with canvas done
        // Biding everything in a promisse so we have control
        // Make an asynchronous call and either resolve or reject

        for (const page of cloneObjectScreen) {
          for (const renderedObject of page.renderObjects) {
            //having this if we make sure the algorithm will just enter in richText
            if (!!renderedObject?.format) {
              quillRefComponent.current
                .getEditor()
                .setText(renderedObject.text);

              quillRefComponent.current.getEditor().root.style.width = String(
                renderedObject.width + "px"
              );

              //setting format inside of quill
              quillRefComponent.current
                .getEditor()
                .setContents(renderedObject.format as any);

              // setting padding of quill for zero
              // very important any quill change to be before rendering the image otherwise
              // you can make it become distorted
              quillRefComponent.current.getEditor().root.style.padding = "0px";

              try {
                const canvas = await html2canvas(
                  quillRefComponent.current.getEditor().root,
                  {
                    scale: 2,
                    backgroundColor: "rgba(0,0,0,0)"
                  }
                );

                // setting the base64 to src on state
                renderedObject.src = canvas.toDataURL();

                //setting the same height on picture to state
                renderedObject.height =
                  quillRefComponent.current.getEditor().root.offsetHeight;

                // setting the same width of picture to state
                renderedObject.width =
                  quillRefComponent.current.getEditor().root.offsetWidth;

                // making the script wait two seconds for visualizing the editor
                await new Promise(res => setTimeout(res, 0));
              } catch (error) {
                console.log("error transforming canva");
              }
            }
          }
        }

        documentAutomatized.current = cloneObjectScreen;
        setLoading(false);
        setIsModalVisible(false);
        setIsModalNameDocumentVisible(true);
      } catch (error) {
        setLoading(null);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          let errorMessage = "";
          let arrayErrors: Array<string> = [];

          Object.keys(errors).forEach(function (item) {
            arrayErrors.push("■ " + errors[item]);
            errorMessage += `${errors[item]} \n `;
          });

          toast.error(" Todos os campos são obrigatórios", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              fontSize: "12pt",
              textAlign: "center"
            }
          });
          return;
        }
      }
    },
    [objectScreen, loading]
  );

  const handleSaveAutomatizedDocument = useCallback(
    async data => {
      const { document_name } = data;
      setLoading("saving");
      try {
        const fetchAPI = await api.post("user-templates", {
          title: document_name,
          template: {
            arrayOfPages: documentAutomatized.current
          },
          is_automation: true,
          automation_user_template_id: templateid
        });

        // updating my list with new document
        setListDocumentsAutomatized(prevState => {
          let cloneState = cloneDeep(prevState);
          cloneState.push(fetchAPI.data);
          cloneState.sort((a, b) => {
            if (a.title > b.title) return 1;
            if (a.title < b.title) return -1;
            return 0;
          });
          return cloneState;
        });
        setIsModalNameDocumentVisible(false);
        setLoading(false);
      } catch (error: any) {
        setLoading(false);

        console.log(error?.response?.data);
        console.log("error on saving automatized document");
      }
    },
    [documentAutomatized, documentID]
  );

  const handlePreviewDocument = useCallback(async (document_id: string) => {
    try {
      setLoading("preview");
      idCurrentAutomatizedDocument.current = document_id;
      const fetchDocumentPreview = await api.get(
        `user-templates/${document_id}`
      );

      const { template, id } =
        fetchDocumentPreview.data as IShowAutomatizedDocumentAPI;

      documentPreviewData.current = template.arrayOfPages;

      setModalPreviewDocumentVisible(true);
      setLoading(false);
    } catch (error) {
      console.log("error getting document to preview");
    }
  }, []);

  const handleEditDocument = useCallback((document_id: string) => {
    window.open(`${document_id}`, "_blank");
    //navigate(`/`, { replace: true });
    //navigate(`editor/my-template/${document_id}`, { replace: true });
  }, []);

  const handleDownloadAutomatizedDocument = useCallback(
    async (document_id: string, document_name: string) => {
      idCurrentAutomatizedDocument.current = document_id;
      documentName.current = document_name;

      const fetchDocumentPreview = await api.get(
        `user-templates/${document_id}`
      );

      const { template } =
        fetchDocumentPreview.data as IShowAutomatizedDocumentAPI;

      documentPreviewData.current = template.arrayOfPages;

      setDownloading(true);
    },
    []
  );

  const handleDeleteAutomatizedDocument = useCallback((document_id: string) => {
    idCurrentAutomatizedDocument.current = document_id;
    setIsModalDeleteDocumentVisible(true);
  }, []);

  const handleConfirmDelete = useCallback(async () => {
    try {
      setLoading("deleting");
      await api.delete(
        `user-templates/${idCurrentAutomatizedDocument.current}`
      );
      setListDocumentsAutomatized(prevState => {
        let cloneState = cloneDeep(prevState);
        cloneState = cloneState.filter(document => {
          return document.id !== idCurrentAutomatizedDocument.current;
        });

        return cloneState;
      });

      setLoading(false);
      idCurrentAutomatizedDocument.current = null;
      setIsModalDeleteDocumentVisible(false);
    } catch (error) {
      setLoading(false);
      console.log("something went wrong on deleting document");
    }
  }, [idCurrentAutomatizedDocument]);

  const handleScrollTab = useCallback(
    async (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
      const { offsetHeight, scrollTop, scrollHeight } =
        automatizedTabRef.current;

      console.log(offsetHeight, scrollTop, scrollHeight);

      //making calculation to know if scroll has reached the end
      if (offsetHeight + scrollTop >= scrollHeight - 1) {
        //getting out of function if page namber doesnt exist anymore
        console.log(automatizedDocumentsPageNumber.current);
        if (automatizedDocumentsPageNumber.current === "FINAL") return;

        automatizedDocumentsPageNumber.current += 1;

        try {
          setLoading("pages");
          const fetchAutomatizedDocuments = await api.get(
            `user-templates/list-automation-user-template/a2632c3d-3973-4aea-98ba-23393bb90fe8?pagination=${automatizedDocumentsPageNumber.current}`
          );

          //veryfing if page came with any data, if not end of list has been reached

          if (fetchAutomatizedDocuments.data.dataArray.length !== 0) {
            setListDocumentsAutomatized(prevState => [
              ...prevState,
              ...fetchAutomatizedDocuments.data.dataArray
            ]);
            setLoading(null);
          } else {
            console.log("FINAL DA LISTA ENTREI");
            automatizedDocumentsPageNumber.current = "FINAL";
            setLoading(null);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    [automatizedTabRef, automatizedDocumentsPageNumber]
  );

  return (
    <ContainerSidebarNav style={{ padding: "0 1.5rem 1.5rem 1.5rem" }}>
      <ButtonPrimary onClick={handleOpenModal} style={{ marginTop: "2.35rem" }}>
        Preencher automação
      </ButtonPrimary>

      <SubContainerSideBarNav
        onScroll={handleScrollTab}
        ref={automatizedTabRef}
      >
        <ListDocumentsContainer>
          {listDocumentsAutomatized.map((itemAutomatize, index) => {
            return (
              <AutomatizedItem
                key={itemAutomatize.id}
                downloading={downloading}
                loading={loading}
                setLoading={setLoading}
                currentSelectedDocument={idCurrentAutomatizedDocument.current}
                document_id={itemAutomatize.id}
                handlePreviewDocument={handlePreviewDocument}
                handleEditDocument={handleEditDocument}
                handleDownloadAutomatizedDocument={
                  handleDownloadAutomatizedDocument
                }
                handleDeleteAutomatizedDocument={
                  handleDeleteAutomatizedDocument
                }
                document_name={itemAutomatize.title}
              />
            );
          })}
        </ListDocumentsContainer>
      </SubContainerSideBarNav>

      <Modal open={IsModalVisible}>
        <ModalContainer onClick={handleCloseModal}>
          <ContainerVariables>
            {loading === "automatizing" ? (
              <ContainerLoading>
                {/* <LoadingEditor /> */}
                <ContractAnimation />
              </ContainerLoading>
            ) : (
              <Form
                ref={formRef}
                onSubmit={handleAutomatizeDocument}
                style={{
                  height: "100%"
                }}
              >
                {documentVariables.length > 0 ? (
                  documentVariables.map(variable => {
                    return <Variables name={variable} variable={variable} />;
                  })
                ) : (
                  <NoVariables>
                    <NoVariablesLabel>
                      Você não possui variaveis de automação em seu documento
                    </NoVariablesLabel>
                  </NoVariables>
                )}

                {documentVariables.length > 0 && (
                  <div style={{ width: "100%", height: "80px" }}>
                    <ButtonPrimary type="submit" style={{ marginTop: "3rem" }}>
                      Salvar
                    </ButtonPrimary>
                  </div>
                )}
              </Form>
            )}
          </ContainerVariables>
          <ReactQuill
            ref={quillRefComponent}
            modules={modules}
            style={{
              fontSize: 18,
              position: "absolute",
              top: "0",
              right: "-1000px",
              maxWidth: "500px",
              backgroundColor: "white",
              // zIndex: "-50",
              resize: "both"
            }}
          />
        </ModalContainer>
      </Modal>

      <Modal open={isModalNameDocumentVisible}>
        <ModalContainer onClick={handleCloseModal}>
          <ContainerModalDocumentName>
            <Form ref={formRef} onSubmit={handleSaveAutomatizedDocument}>
              <LabelDocumentName>Nome do documento</LabelDocumentName>
              <Input
                name="document_name"
                containerStyle={{ marginTop: "0.5rem" }}
              />

              <ButtonPrimary
                disabled={loading === "saving"}
                type="submit"
                style={{ marginTop: "3rem" }}
              >
                {loading ? (
                  <ContainerLoading>
                    <LoadingEditor color="#FFF" width={30} height={30} />
                  </ContainerLoading>
                ) : (
                  "Salvar"
                )}
              </ButtonPrimary>
            </Form>
          </ContainerModalDocumentName>
        </ModalContainer>
      </Modal>

      <Modal open={isModalDeleteDocumentVisible}>
        <ModalContainer onClick={handleCloseModal}>
          <ContainerModalDocumentName>
            <LabelDocumentName>
              Você realmente deseja excluir ?
            </LabelDocumentName>
            <ContainerButtonsYesNo>
              <ButtonPrimary
                disabled={loading === "deleting"}
                onClick={handleConfirmDelete}
              >
                {loading === "deleting" ? (
                  <ContainerLoading>
                    <LoadingEditor color="#FFF" width={30} height={30} />
                  </ContainerLoading>
                ) : (
                  "Sim"
                )}
              </ButtonPrimary>
              <ButtonPrimary
                onClick={() => {
                  setIsModalDeleteDocumentVisible(false);
                }}
                style={{
                  marginLeft: "0.5rem",
                  backgroundColor: "#FFF",
                  border: "solid",
                  borderWidth: "1px",
                  borderColor: "#000",
                  overflow: "hidden"
                }}
              >
                <LabelDocumentName>Não</LabelDocumentName>
              </ButtonPrimary>
            </ContainerButtonsYesNo>
          </ContainerModalDocumentName>
        </ModalContainer>
      </Modal>

      <PreviewDocument
        open={modalPreviewDocumentVisiblle}
        handleCloseModal={handleCloseModal}
        pagesToBeRendered={documentPreviewData.current}
      />

      <DownloadDocument
        downloading={downloading}
        setDownloading={setDownloading}
        documentName={documentName.current}
        pagesToBeRendered={documentPreviewData.current}
      />

      {loading === "pages" && (
        <div style={{ marginTop: 10 }}>
          <LoadingEditor color="#111" width={30} height={30} />
        </div>
      )}
    </ContainerSidebarNav>
  );
};

export default AutomatizingTab;
